import Card from '@raydiant/raydial/components/Card';
import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';
import DisplaiDeviceImage from './images/displai-device.svg';
import { useHistory } from 'react-router-dom';
import * as paths from '../../routes/paths';
import analytics from '../../clients/analyticsClient';

const GetAPlanNowCard = () => {
  const history = useHistory();

  const onButtonPress = () => {
    analytics.trackGetPlanCTAClicked({
      page: 'getting_started',
      buttonLocation: 'card',
    });
    history.push(paths.plans('pro'));
  };

  return (
    <Card className="w-full xl:max-w-[628px] border-[4px] border-white bg-teal-50 pt-7 px-6 pb-5 flex gap-8">
      <img
        src={DisplaiDeviceImage}
        alt="Displai Device"
        className="max-w-[122px]"
        style={{ aspectRatio: '61 / 65' }}
      />

      <div className="flex flex-col justify-between">
        <div className="flex flex-col gap-2 text-black">
          <Text variant="subheader">Power your screens with a plan</Text>
          <Text variant="body">
            To use Displai for your screens, you will need a Displai Pro plan.
            Each plan comes with a Displai player and a Displai License.
          </Text>
        </div>

        <Button
          variant="primary"
          className="bg-blue-600 text-white w-[162.5px] mt-4 md:mt-0"
          onPress={onButtonPress}
        >
          Get a plan now
        </Button>
      </div>
    </Card>
  );
};

export default GetAPlanNowCard;
